import { ArrowRight, Play } from 'lucide-react';

const WA_GENERIC = 'https://api.whatsapp.com/send/?phone=5562994767293&text&type=phone_number&app_absent=0';

export default function Hero() {
  const scrollTo = (id) => {
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1758518726324-62bef7c815b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHBlb3BsZSUyMG1lZXRpbmclMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzc2NDgwNTY1fDA&ixlib=rb-4.1.0&q=85)',
        }}
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-[#0A2540]/80" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-24 pb-16 md:pt-32 md:pb-24 w-full">
        <div className="max-w-3xl">
          {/* Badge */}
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-2xl border border-white/20 text-white/80 text-xs font-semibold tracking-[0.2em] uppercase mb-8"
            style={{ animationDelay: '0.1s' }}
          >
            <span className="w-2 h-2 rounded-full bg-[#10B981]" />
            Especialistas em MEI e Simples Nacional
          </div>

          {/* Headline */}
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-none mb-6"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-2px' }}
          >
            Sua contabilidade simples,
            <br />
            <span className="text-[#10B981]">sua empresa crescendo.</span>
          </h1>

          {/* Subheadline */}
          <p className="text-base sm:text-lg text-white/75 leading-relaxed max-w-xl mb-10">
            Focamos na burocracia para você focar no que importa: o sucesso do seu negócio.
            Especialistas em PMEs e MEIs em todo o Brasil.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={WA_GENERIC}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="bg-[#10B981] text-white px-8 py-4 rounded-lg font-semibold text-base hover:bg-[#059669] transition-colors flex items-center justify-center gap-2"
            >
              Fale com um contador
              <ArrowRight size={18} />
            </a>
            <button
              data-testid="hero-cta-services"
              onClick={() => scrollTo('#servicos')}
              className="bg-transparent border border-white/30 text-white px-8 py-4 rounded-lg font-semibold text-base hover:bg-white/10 transition-colors flex items-center justify-center gap-2"
            >
              <Play size={16} />
              Nossos Serviços
            </button>
          </div>

          {/* Trust indicators */}
          <div className="flex items-center gap-8 mt-14 pt-8 border-t border-white/10">
            <div>
              <p className="text-2xl font-bold text-white">500+</p>
              <p className="text-xs text-white/50 uppercase tracking-wider">Clientes ativos</p>
            </div>
            <div className="w-px h-10 bg-white/15" />
            <div>
              <p className="text-2xl font-bold text-white">10+</p>
              <p className="text-xs text-white/50 uppercase tracking-wider">Anos no mercado</p>
            </div>
            <div className="w-px h-10 bg-white/15" />
            <div>
              <p className="text-2xl font-bold text-white">98%</p>
              <p className="text-xs text-white/50 uppercase tracking-wider">Satisfação</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
